// Chart global styles (Recharts / shadcn charts)

export default function StyledChart() {
  // Global styles are now handled via CSS/Tailwind
  // Return null as we don't need a GlobalStyles component
  return null;
}
